import { parseISO, format } from "date-fns";

const DISPLAY_FORMAT = "LLL dd, yyyy";

export const dbDateStringToDisplay = (dateString) => {
  const parsedDate = parseISO(dateString);
  return format(parsedDate, DISPLAY_FORMAT);
};
